import { useCallback } from 'react';

import AddLink from '~components/generic/elements/add-link/AddLink';
import { IEntityComponentProps } from '~interfaces/props';
import { createNewRawAnnotation } from './AnnotationUtils';

export type AddAnnotationProps = {
  editing: boolean;
  onChange: IEntityComponentProps['onChange'];
};

export const AddAnnotation = ({ editing, onChange }: AddAnnotationProps) => {
  const handleAddItem = useCallback(() => {
    onChange(`attributes.field_annotations_items`, createNewRawAnnotation(), true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return editing ? <AddLink className={{ 'u-block': true, 'u-margin-top-md': true }} onClick={handleAddItem} /> : null;
};
